import { createApi } from "@reduxjs/toolkit/query/react";
import { customFetchBase } from "../../utils/API/fetchBaseQuery";
import { transformErrorResponse, transformSuccessResponse } from "../../utils/API/responseMiddleware";
import { transformRequest } from "../../utils/API/requestMiddleware";


// Create priority API
const backLogAPI = createApi({
  reducerPath: "backLogAPI",
  baseQuery: customFetchBase,
  endpoints: (builder) => ({
    //Back Log API EndPoint
    getAllTaskByProjectId: builder.query({
      query: (projectId) => ({
        url: `/Task/GetAllTaskByProjectId?projectId=${Number(projectId)}`,
        method: 'GET',
      }),
      transformResponse: transformSuccessResponse,
      transformErrorResponse: transformErrorResponse,
    }),

    //BackLog Task Update API EndPoint  
    updateBacklogTask: builder.mutation({
      query: (data) => ({
        url: `/Task/UpdateBacklogTask`,
        method: 'POST',
        body: transformRequest(data),
      }),
      transformResponse: transformSuccessResponse,
      transformErrorResponse: transformErrorResponse,
    }),
  }),
})

// Extract hooks for easy access to various API requests 
export const {
  useLazyGetAllTaskByProjectIdQuery,
  useUpdateBacklogTaskMutation,
} = backLogAPI;

export default backLogAPI;